export interface SafeAreaInsets {
  readonly bottom: number;
  readonly left: number;
  readonly right: number;
  readonly top: number;
}

export const safeAreaProperties = {
  bottom: "--snakely-safe-area-bottom",
  left: "--snakely-safe-area-left",
  right: "--snakely-safe-area-right",
  top: "--snakely-safe-area-top",
} as const;

const zeroSafeAreaInsets: SafeAreaInsets = {
  bottom: 0,
  left: 0,
  right: 0,
  top: 0,
};

const parseInset = (value: string): number => {
  const inset = Number.parseFloat(value);
  return Number.isFinite(inset) ? Math.max(0, inset) : 0;
};

export const readSafeAreaInsets = (documentScope: Document): SafeAreaInsets => {
  const windowScope = documentScope.defaultView;
  if (windowScope === null) {
    return zeroSafeAreaInsets;
  }
  const style = windowScope.getComputedStyle(documentScope.documentElement);
  return {
    bottom: parseInset(style.getPropertyValue(safeAreaProperties.bottom)),
    left: parseInset(style.getPropertyValue(safeAreaProperties.left)),
    right: parseInset(style.getPropertyValue(safeAreaProperties.right)),
    top: parseInset(style.getPropertyValue(safeAreaProperties.top)),
  };
};
